import React from 'react';
import Translate from '../../../../Translate/Translate';
import LoadingIndicator from '../../../../LoadingIndicator/LoadingIndicator';

const List = React.lazy(() => import('./notifications/Container'));

function Fallback() {
    return <div className="notifications__list">
        <div className="notifications__list__body py-5 px-2 text-center">
            <LoadingIndicator type="border" size="sm" className="me-2"/> <Translate message="@common-phrases.loading"/>
        </div>
    </div>;
}

export default function NotificationsList(props: {
    headerRef?: React.RefObject<HTMLDivElement>,
    footerRef?: React.RefObject<HTMLDivElement>,
    contentRef?: React.RefObject<HTMLDivElement>,
}) {
    return <React.Suspense fallback={<Fallback/>}>
        <List {...props}/>
    </React.Suspense>;
}
